/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionDisputeResolution } from './CompetitionDisputeResolution';
import {
    CompetitionDisputeResolutionFromJSON,
    CompetitionDisputeResolutionFromJSONTyped,
    CompetitionDisputeResolutionToJSON,
    CompetitionDisputeResolutionToJSONTyped,
} from './CompetitionDisputeResolution';

/**
 * 
 * @export
 * @interface CompetitionMatchDispute
 */
export interface CompetitionMatchDispute {
    /**
     * 
     * @type {boolean}
     * @memberof CompetitionMatchDispute
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompetitionMatchDispute
     */
    raisedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof CompetitionMatchDispute
     */
    raisedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof CompetitionMatchDispute
     */
    reason?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompetitionMatchDispute
     */
    evidence?: Array<string>;
    /**
     * 
     * @type {CompetitionDisputeResolution}
     * @memberof CompetitionMatchDispute
     */
    resolution?: CompetitionDisputeResolution;
    /**
     * 
     * @type {string}
     * @memberof CompetitionMatchDispute
     */
    chatChannelId?: string;
}

/**
 * Check if a given object implements the CompetitionMatchDispute interface.
 */
export function instanceOfCompetitionMatchDispute(value: object): value is CompetitionMatchDispute {
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function CompetitionMatchDisputeFromJSON(json: any): CompetitionMatchDispute {
    return CompetitionMatchDisputeFromJSONTyped(json, false);
}

export function CompetitionMatchDisputeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionMatchDispute {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'],
        'raisedBy': json['raisedBy'] == null ? undefined : json['raisedBy'],
        'raisedAt': json['raisedAt'] == null ? undefined : json['raisedAt'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'evidence': json['evidence'] == null ? undefined : json['evidence'],
        'resolution': json['resolution'] == null ? undefined : CompetitionDisputeResolutionFromJSON(json['resolution']),
        'chatChannelId': json['chatChannelId'] == null ? undefined : json['chatChannelId'],
    };
}

export function CompetitionMatchDisputeToJSON(json: any): CompetitionMatchDispute {
    return CompetitionMatchDisputeToJSONTyped(json, false);
}

export function CompetitionMatchDisputeToJSONTyped(value?: CompetitionMatchDispute | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
        'raisedBy': value['raisedBy'],
        'raisedAt': value['raisedAt'],
        'reason': value['reason'],
        'evidence': value['evidence'],
        'resolution': CompetitionDisputeResolutionToJSON(value['resolution']),
        'chatChannelId': value['chatChannelId'],
    };
}

